/**
 * Created by eliranm on 10/11/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var BaseCollection = require('collections/BaseCollection');
    var ContentImportErrorsModel = require('content-models/ContentImportErrorsModel');

    var ContentImportErrorsCollection = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportErrorsCollection = BaseCollection.extend({
            name: "ContentImportErrorsCollection",
            model: ContentImportErrorsModel,

            /**
             * parsing the server response for content import to a valid collection.
             *
             * @param response
             * @returns {Array}
             */
            parse: function (response) {
                if (!response) {
                    return [];
                }
                var collection = [],
                    rows = response.rows; // get the relevant property to parse
                _.forOwn(rows, function (row) {
                    // populate keys and values for the model object
                    var keys = [],
                        values = [];
                    _.forEach(row.columns, function (cell) {
                        if (cell) {
                            keys.push(cell.name);
                            values.push({name: cell.name, value: cell.value, errors: cell.errors});
                        }
                    });
                    // add a special attribute for row number
                    keys.push(ContentImportErrorsModel.KEYS.rowIndex);
                    values.push(row.index);
                    // zip the model object and add it to the collection
                    collection.push(_.zipObject(keys, values));
                });
                return collection;
            }

        });
    });

    return ContentImportErrorsCollection;
});
